import { closeMenubar } from "assets/images";
import { FC, useState, useEffect } from "react";
import { useNavigate } from "react-router-dom";
import Drawer from "react-modern-drawer";
import ProfilePc from "pagesPc/Home/ProfilePc";
import NotificationPc from "pagesPc/Home/notificationPc/NotificationPc";
import SettingsPc from "pagesPc/Home/SettingsPc";
import { appVersion } from "services/config/url";
import OtpModal from "utils/other/OtpModal";
import { getTheme } from "utils/v2/theme";
import { useBrandsConfig } from "utils/v2/BrandsConfig/BrandsConfigContext";
import { useSelector, useDispatch } from "react-redux";
import {
  closeNotificationDrawer,
  openNotificationAndChat,
} from "redux/drawerSlice/drawerSlice";
import { useChatIndexQuery } from "redux/RTQ/IlenkradApi";
import { toPersianNumbers } from "common/common";

interface IpropsChild {
  children: JSX.Element;
  switchTheme: () => void;
  checkFcm: () => void;
}
const HomeLayoutPc: FC<IpropsChild> = ({ children, switchTheme, checkFcm }) => {
  const { overrideLogo, title } = useBrandsConfig();
  const theme = getTheme();
  const { data: dataChat } = useChatIndexQuery();
  const itemMenuBar = [
    {
      name: "خانه",
      key: 1,
      icon: "icon-homePc",
      page: "/home",
      active: true,
    },
    {
      name: "ردیاب ها",
      key: 2,
      icon: "icon-trackerPc",
      page: "/trackers",
      active: false,
    },
    {
      name: "تمدید سامانه",
      key: 3,
      icon: "icon-paymentPc",
      page: "/transactions",
      active: false,
    },
    {
      name: "سرویس ها",
      key: 4,
      icon: "icon-servicesPc",
      page: "/services",
      active: false,
    },
    {
      name: "گزارشات",
      key: 5,
      icon: "icon-reportPc",
      page: "/reports",
      active: false,
    },
    {
      name: "محدوده جغرافیایی",
      key: 6,
      icon: "icon-GeographicAreaPc",
      page: "/limitations",
      active: false,
    },
    {
      name: "پشتیبانی",
      key: 7,
      icon: "icon-supportCallPc",
      page: "/contact-us",
      active: false,
    },
    {
      name: "چت با پشتیبانی",
      key: 8,
      icon: "icon-messagePc",
      page: "/support-chat",
      active: false,
      isDrawerAction: true,
    },
  ];
  const navigate = useNavigate();
  const dispatch = useDispatch();
  const drawerState = useSelector((state: any) => state.drawer);
  const [closeMenu, setCloseMenu] = useState<boolean>(false);
  const [pageDrawer, setPageDrawer] = useState<string>("");
  const [isOpen, setIsOpen] = useState<boolean>(false);
  const [tooltip, setTooltip] = useState<boolean>(false);
  const [openModalOpt, setOpenModalOpt] = useState<boolean>(false);
  const [new_phone_number, setNewPhoneNumber] = useState<boolean>(false);
  const [phone_number_changed, setPhoneNumberChanged] =
    useState<boolean>(false);

  // Listen to Redux drawer state and open notification drawer
  useEffect(() => {
    if (drawerState.isNotificationDrawerOpen) {
      openDrawer("notification");
    }
  }, [drawerState.isNotificationDrawerOpen]);

  const openDrawer = (name: string) => {
    setIsOpen(true);
    setPageDrawer(name);
  };
  const closeDrawer = () => {
    setIsOpen(false);
    setPageDrawer("");
    dispatch(closeNotificationDrawer());
  };
  const toggleMenubar = () => {
    setCloseMenu(!closeMenu);
  };

  const changePage = (page: string, isDrawerAction?: boolean) => {
    if (isDrawerAction) {
      // Handle opening support chat in drawer
      const supportChat = dataChat?.chats?.find(
        (chat: any) => chat?.title === "پشتیبانی",
      );
      if (supportChat) {
        dispatch(openNotificationAndChat(supportChat.id));
      }
    } else {
      navigate(`${page}`);
    }
  };

  const changeTheme = () => {
    switchTheme();
    setTooltip(false);
  };

  const showModalOpt = () => {
    //FIXIT: we should not navigate to home
    setOpenModalOpt(!openModalOpt);
    setTimeout(() => {
      closeDrawer();
    }, 600);
    setTimeout(() => {
      openDrawer("profile");
    }, 700);
  };

  return (
    <>
      <Drawer
        open={isOpen}
        direction="left"
        size={400}
        overlayOpacity={0.7}
        zIndex={9990}
      >
        {pageDrawer === "profile" ? (
          <ProfilePc
            closeDrawer={closeDrawer}
            phone_number_changed={phone_number_changed}
            setNewPhoneNumber={setNewPhoneNumber}
            setPhoneNumberChanged={setPhoneNumberChanged}
            setOpenModalOpt={setOpenModalOpt}
          />
        ) : pageDrawer === "settings" ? (
          <SettingsPc checkFcm={checkFcm} closeDrawer={closeDrawer} />
        ) : (
          <NotificationPc closeDrawer={closeDrawer} />
        )}
      </Drawer>
      <div className="layoutContainerPC">
        <div
          className={
            !closeMenu
              ? "menubarPC scrollbar-div"
              : "menubarPcClose scrollbar-div"
          }
        >
          <div
            className={
              !closeMenu && title === "Lenkrad"
                ? "containerMenubarLogoPc"
                : !closeMenu && title === "WEGA"
                  ? "containerMenubarLogoPcWega"
                  : "containerMenubarLogoPcClose"
            }
          >
            <div
              onClick={toggleMenubar}
              className="closeMenubarAbsolute pointer"
            >
              <img
                src={closeMenubar}
                alt="closeMenubar"
                className="closeMenubarIcon"
              />
            </div>

            {!closeMenu ? (
              <img src={overrideLogo} alt="logoImg" className="logoImgPcc" />
            ) : null}
          </div>
          <div
            className={
              !closeMenu
                ? "containerItemMenubarPc"
                : "containerItemMenubarPcClose"
            }
          >
            {itemMenuBar.map((item) => (
              <div
                key={item.key}
                onClick={() => changePage(item.page, item.isDrawerAction)}
                className={
                  !closeMenu
                    ? window.location.pathname.includes(item.page)
                      ? "rowItemMenubarPc pointer activeItemMenubar"
                      : "rowItemMenubarPc pointer notactiveItemMenubar"
                    : window.location.pathname.includes(item.page)
                      ? "rowItemMenubarPcClose pointer activeItemMenubarClose"
                      : "rowItemMenubarPcClose pointer notactiveItemMenubarClose"
                }
              >
                <div className={`${item.icon}`} />
                {!closeMenu ? (
                  <div className="titleMenubarPc">{item.name}</div>
                ) : null}
              </div>
            ))}
            <div
              className={
                !closeMenu
                  ? "appVersionPcOpenMenubar"
                  : "appVersionPcCloseMenubar"
              }
            >
              {" "}
              نسخه {toPersianNumbers(appVersion ?? '')}
            </div>
          </div>
        </div>
        <div className={!closeMenu ? "containerPC" : "containerPCClose"}>
          <div className={!closeMenu ? "navbarPC" : "navbarPcClose"}>
            {tooltip ? (
              <div className="tooltipHover">
                <div
                  onClick={changeTheme}
                  className={
                    theme === "light"
                      ? "rowThemeItemPc ActiveThemePc"
                      : "rowThemeItemPc"
                  }
                >
                  <div className="icon3-light_modePcc pointer" />
                  <div className="fontColorThemePc">روشن</div>
                </div>
                <div
                  onClick={changeTheme}
                  className={
                    theme === "dark"
                      ? "rowThemeItemPc ActiveThemePc"
                      : "rowThemeItemPc"
                  }
                >
                  <div className="icon5-bedtimePc pointer" />
                  <div className="fontColorThemePc">تیره</div>
                </div>
              </div>
            ) : null}
            <div className="itemNavbarPc">
              {/* <img className="loginFlagPc pointer" src={GermanyFlag} /> */}
              <div
                onClick={() => {
                  openDrawer("settings");
                  setTooltip(false);
                }}
                className="icon-settingsPc pointer"
              />
              <div
                onClick={() => setTooltip(!tooltip)}
                className="icon3-light_modePc pointer"
              />
              <div
                onClick={() => {
                  openDrawer("notification");
                  setTooltip(false);
                }}
                className="icon-bubblesPc pointer"
              />
              <div
                onClick={() => {
                  openDrawer("profile");
                  setTooltip(false);
                }}
                className="icon-userPc pointer"
              />
            </div>
          </div>
          <div
            className={
              !closeMenu
                ? "contentPC scrollbar-div"
                : "contentPcClose scrollbar-div"
            }
          >
            {children}
          </div>
        </div>
        {openModalOpt && (
          <OtpModal
            open={openModalOpt}
            onClose={showModalOpt}
            newMobile={new_phone_number}
            setPhoneNumberChanged={setPhoneNumberChanged}
            closeDrawer={closeDrawer}
            openDrawer={openDrawer}
          />
        )}
      </div>
    </>
  );
};

export default HomeLayoutPc;
